{
  "filterButtonText": "Finn...",
  "sortLabel": "Sortering",
  "resetButtonText": "Nullstill",
  "showButtonText": "Vis {0} treff",
  "filterOverviewTitle": "Finn...",
  "searchPlaceholder": "Søk i listen",
  "searchClearButtonAriaLabel": "Nullstill",
  "searchButtonAriaLabel": "Søk"
}
